<template>
    <div class="container-scroller login-page" id="login-page">
        <b-container fluid class="page-body-wrapper full-page-wrapper">
            <div class="content-wrapper d-flex align-items-center auth">
                <b-row class="flex-grow">
                    <b-col lg="7" md="12" sm="12" class="mx-auto">
                        <b-row class="auth-form-light text-left">
                            <b-col class="col-lg-6 left-side col-md-12 col-sm-12">
                                <div class="brand-logo text-center">
                                    <img src="@/assets/images/logo.png" />
                                </div>
                                <h4>{{ $translate('sign_in_note') }}</h4>
                                <b-alert variant="danger" :show="!!signInError">{{ signInError }}</b-alert>
                                <b-form @submit="e => login(e)" class="pt-3">
                                    <b-form-group>
                                        <b-form-input type="email" class="form-control form-control-sm"
                                            v-model="model.email" :placeholder="$translate('username')" required
                                            v-custom-validation="$textRequired()" />
                                    </b-form-group>
                                    <b-form-group>
                                        <b-form-input type="password" class="form-control form-control-sm"
                                            v-model="model.password" :placeholder="$translate('password')" required
                                            v-custom-validation="$textRequired()" />
                                    </b-form-group>
                                    <div class="d-flex justify-content-between">
                                        <b-dropdown variant="light" toggle-class="d-flex align-items-center gap-2"
                                            menu-class="dropdown-menu flag-dropdown navbar-dropdown">
                                            <template #button-content>
                                                <div>
                                                    <span :class="selectedLanguage.flagClass"></span>
                                                    <span>{{ selectedLanguage.label }}</span>
                                                </div>
                                            </template>
                                            <b-dropdown-item v-for="language in languages" :key="language.id"
                                                @click="changeLanguage(language.id)">
                                                <i :class="language.flagClass"></i> {{ language.label }}
                                            </b-dropdown-item>
                                        </b-dropdown>
                                        <div class="align-self-center">
                                            <router-link to="/forgot_password" class="auth-link text-black">
                                                {{ $translate('forgot') }}
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="mb-2 mt-4">
                                        <b-button type="submit" class="btn btn-block btn-facebook auth-form-btn col-12 m-0"
                                            :disabled="signingIn ? true : false">{{
                                                signingIn
                                                ? $translate('signing_in')
                                                : $translate('sign_in')
                                            }}</b-button>
                                    </div>
                                </b-form>
                            </b-col>

                            <div class="col-lg-7 bg-white slider-bar col-md-12 col-sm-12">
                                <Slider />
                            </div>
                        </b-row>
                    </b-col>
                </b-row>
            </div>
        </b-container>
    </div>
</template>
<script>

import Slider from '@/components/Login/slider.vue'
export default {
    name: 'login',
    data() {
        return {
            signingIn: false,
            signInError: false,
            model: {
                email: '',
                password: '',
            },
            languages: [
                { id: 'en', label: 'English', flagClass: 'flag-uk' },
                { id: 'es', label: 'Español', flagClass: 'flag-spain' }
            ],
            selectedLanguage: ''
        }
    },
    components: {
        Slider,
    },
    watch: {
        '$i18n.locale': {
            immediate: true,
            handler(val) {
                this.selectedLanguage = this.languages.find(language => language.id === val);
            }
        }
    },
    methods: {
        changeLanguage(obj) {
            if (this.$i18n.locale !== obj) {
                this.$i18n.locale = obj
                localStorage.setItem('language', obj)
                this.$router.go(0)
            }
        },
        login(e) {
            e.preventDefault()
            this.signingIn = true
            this.$store
                .dispatch('login', {
                    email: this.model.email,
                    password: this.model.password,
                })
                .then(() => {
                    // route to dashboard
                    this.$router.push('dashboard')
                })
                .catch(error => {
                    this.signInError = error.response.data.error.message || error.message
                })
                .finally(() => {
                    this.signingIn = false
                })
        },
    },
}
</script>
